var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.HOSPITAL.domain=='cd')?_vm._t("cd"):(_vm.HOSPITAL.domain=='sz')?_vm._t("sz"):(_vm.HOSPITAL.domain=='hf')?_vm._t("hf"):_vm._e(),_vm._t("common")],2)}
var staticRenderFns = []

export { render, staticRenderFns }